import { createAsyncThunk } from '@reduxjs/toolkit';

import { IStructuredEssayQuestion } from '.';
import { APIDataProvider, TApiResponse, ApiPaths } from '../../api';

export interface IStudentAnswer {
  subQuestionId: string;
  answer?: string;
  imageUrl?: string;
}

export interface IGetAiResponse {
  questionId: string;
  answers: IStudentAnswer[];
}

export interface ISubQuestionVerdict {
  subQuestionId: string;
  verdict: 'Correct' | 'Partially Correct' | 'Incorrect' | string;
  givenMarks: number;
  analysis: string;
}

export interface IAiResponse {
  questionId: string;
  evaluations: ISubQuestionVerdict[];
}

const apiDataProvider = new APIDataProvider();

export const getRandomStructuredQuestionsBySubTopic = createAsyncThunk(
  'structuredEssay/random/subTopic',
  async (subTopic: string) => {
    const response = await apiDataProvider.get<
      TApiResponse<IStructuredEssayQuestion[]>
    >(`${ApiPaths.structuredEssayQuestions}/random/${subTopic}`);

    return response.data;
  }
);

export const getAiResponse = createAsyncThunk(
  'structuredEssay/aiResponse',
  async (data: IGetAiResponse) => {
    const response = await apiDataProvider.post<TApiResponse<IAiResponse>>(
      `${ApiPaths.structuredEssayQuestions}/aiResponse`,
      data
    );

    return response.data;
  }
);
